import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { SourceStoreModel } from './source.model';

export interface SourceState extends EntityState<SourceStoreModel> {}

@Injectable({ providedIn: 'root' })
export class SourceStore extends EntityStore<SourceState, SourceStoreModel, 'id'> {
  constructor() {
    super({
      name: 'sources',
      idKey: 'id',
    });
  }
}
